<template>
  <a-modal title="编辑部门" okText="保存" @ok="save" v-model="visible" :confirmLoading="confirmLoading">
    <a-form :form="form">
      <a-form-item v-bind="formItemLayout" label="部门名称">
        <a-input v-decorator="['name', {rules: [{required: true, message: '请填写部门名称'}]}]"></a-input>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="备注">
        <a-textarea :rows="4" v-decorator="['remark']"></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from '@/api'
export default {
  name: "AddOrganizationModal",
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      record: {},
      visible: false,
      confirmLoading: false,
    };
  },
  methods: {
    save() {
      this.form.validateFields((err, values) => {
        if(!err) {
          this.confirmLoading =  true;
          Api.office.update({
            name: values.name,
            remark: values.remark,
            id: this.record.id
          }).then(() => {
            this.confirmLoading = false;
            this.close();
            this.$emit('ok');
          })
        }
      })
    },
    show() {
      this.visible = true;
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          name: this.record.name,
          remark: this.record.remark
        });
      });
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
